import { z } from 'zod/v4';

const REMINDER_DOCUMENT_TYPES = ['additional_reminder', 'formal_notice'] as const;
export type ReminderDocumentType = (typeof REMINDER_DOCUMENT_TYPES)[number];

const PreviewReminderVariablesSchema = z.object({
  invoiceId: z.string(),
  templateId: z.string(),
  documentType: z.enum(REMINDER_DOCUMENT_TYPES),
  addLateFees: z.boolean(),
  additionalInvoiceIds: z.array(z.string()),
  creditNoteIds: z.array(z.string()),
  accountingPaymentIds: z.array(z.string()),
  tpPaymentIds: z.array(z.string()),
});

export type PreviewReminderVariables = z.infer<typeof PreviewReminderVariablesSchema>;

export const buildPreviewReminderParams = (variables: PreviewReminderVariables) => ({
  templateId: variables.templateId,
  documentType: variables.documentType,
  addLateFees: variables.addLateFees,
  additionalInvoices: variables.additionalInvoiceIds,
  creditNotes: variables.creditNoteIds,
  accountingPayments: variables.accountingPaymentIds,
  tpPayments: variables.tpPaymentIds,
});
